import React from 'react';

import { TableRowSection } from './TableRowSection';
import { FullWarningEvent } from '../../restapi/types';
import { toggleValue } from './utils';


interface Props {
	events: FullWarningEvent[];
	selected: number[];
	onSelectionChange: (selected: number[]) => void;
}

export function TablePreview({events, selected, onSelectionChange}: Props) {
	return <table className="table-preview">
		<thead>
		<tr>
			<td/>
			<td>RB</td>
			<td>Country</td>
			<td>Warning</td>
			<td>Raised on</td>
			<td>Risk update</td>
			<td>Likelihood</td>
			<td>Impact</td>
			<td>Seriousness</td>
			<td/>
		</tr>
		</thead>
		<tbody>
		{events.map(e =>
			<TableRowSection
				key={e.id}
				event={e}
				selected={selected.includes(e.id)}
				onToggleSelection={() => onSelectionChange(toggleValue(selected, e.id))}
			/>
		)}
		</tbody>
	</table>;
}
